import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance2pj4711kc59sc as Data_getInstance } from './adapter/SavePartyMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SavePartyMutation_VariablesAdapter_instance2b046dcm3k15j as SavePartyMutation_VariablesAdapter_instance } from './adapter/SavePartyMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(saveParty) {
        this.f6g_1 = saveParty;
      }
      toString() {
        return 'Data(saveParty=' + this.f6g_1 + ')';
      }
      hashCode() {
        return this.f6g_1 == null ? 0 : getBooleanHashCode(this.f6g_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.f6g_1 == other.f6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.g6g_1 = '5b3ae51d8ade4a5c5d05a76c9456f084fb3e26e5c7a80059ecbaefaf290cfef0';
        this.h6g_1 = 'saveParty';
      }
      h6e() {
        return 'mutation saveParty($input: SavePartyInput!) { saveParty(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SavePartyMutationClass;
function SavePartyMutation() {
  if (SavePartyMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.i6g_1 = input;
      }
      j6e() {
        return '5b3ae51d8ade4a5c5d05a76c9456f084fb3e26e5c7a80059ecbaefaf290cfef0';
      }
      operationId() {
        return this.j6e();
      }
      i48() {
        return Companion_instance.h6e();
      }
      k6e() {
        return 'saveParty';
      }
      operationName() {
        return this.k6e();
      }
      c47(writer, customScalarAdapters, withDefaultValues) {
        SavePartyMutation_VariablesAdapter_instance.j6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      b47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'SavePartyMutation(input=' + this.i6g_1.toString() + ')';
      }
      hashCode() {
        return this.i6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyMutation()))
          return false;
        if (!this.i6g_1.equals(other.i6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyMutation', VOID, VOID, [Mutation()]);
    SavePartyMutationClass = $;
  }
  return SavePartyMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Datajamxha8esaab,
  SavePartyMutation as SavePartyMutation37kzgcr2r74ko,
};
//endregion

//# sourceMappingURL=SavePartyMutation.mjs.map
